import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OtpInputComponent, RxAlertModule } from '@roomex/rx-components';
import { TRANSLATION_SCOPE, translationProvider } from './i18n/translation.provider';
import { TranslocoDirective } from '@ngneat/transloco';
import { AuthConfig, AuthConfigService, AuthFacade } from '@rx-applications/shared/auth/data-access';
import { LoginHeaderComponent } from '@rx-applications/shared/auth/ui';
import { ResendCodeComponent } from '../components/resend-code/resend-code.component';
import { NavigationStart, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'rx-applications-feature-verify',
  standalone: true,
  imports: [CommonModule, OtpInputComponent, TranslocoDirective, LoginHeaderComponent, ResendCodeComponent, RxAlertModule],
  templateUrl: './feature-verify.component.html',
  styleUrl: './feature-verify.component.scss',
  providers: [translationProvider],
})
export class FeatureVerifyComponent implements OnDestroy, OnInit {
  protected readonly TRANSLATION_SCOPE = TRANSLATION_SCOPE;
  protected authConfig: AuthConfig = inject(AuthConfigService).config;
  protected authFacade: AuthFacade = inject(AuthFacade);
  private routerEvents$ = inject(Router).events.pipe(takeUntilDestroyed());

  ngOnInit(): void {
    this.routerEvents$.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.cleanup();
      }
    });
  }

  resendCode(): void {
    this.authFacade.resendCode();
  }

  confirmCode(mfaCode: string): void {
    this.authFacade.confirmCode(mfaCode);
  }

  ngOnDestroy(): void {
    this.cleanup();
  }

  private cleanup(): void {
    this.authFacade.resetUsersData();
  }
}
